export default {
  data() {
    return {
      filters: {},
      searchTerm: '',
    };
  },
  methods: {
    // Api fetch method for vuetable
    async fetchData(apiUrl, httpOptions) {
      // Retrieve filters from the store
      const storeFilters = this.$store.state.filtersStore.filters[this.$route.name];
      if (storeFilters && storeFilters.general) {
        this.searchTerm = this.$store.state.filtersStore.filters[this.$route.name].general;
      } else if (storeFilters) {
        this.searchTerm = '';
        this.filters = this.$store.state.filtersStore.filters[this.$route.name];
      }
      // Vuetable sort is given in the form "sort=field|order"
      // Here, this is adjusted to our API as "sort[field]=order"
      let sortOptions = [];
      if (httpOptions.params.sort) {
        sortOptions = httpOptions.params.sort.split('|');
      }

      // Assign sortOptions to variables
      if (sortOptions.length === 2) {
        [this.sortField, this.sortOrder] = sortOptions;
      }

      // Only set params when we have updated values, otherwise give a null value.
      const perPage = (this.preferences.perPage !== this.perPage ? `perPage=${this.perPage}` : null);
      const page = (this.preferences.page !== this.page ? `page=${this.page}` : null);

      // This needs to be retained on page and per_page updates too.
      const preSort = (this.preferences.sortOrder !== this.sortOrder
        || this.preferences.sortField !== this.sortField
        || this.preferences.page !== this.page
        || this.preferences.per_page !== this.per_page
        ? `sort[${this.sortField}]=${this.sortOrder}&page=${this.page}` : null);

      // Assign preSort if sort is present in httpOptions
      let sort = httpOptions.params.sort === '' ? null : preSort;

      // Certain sort fields
      if (this.customSort) {
        switch (this.customSort.field) {
          case 'usergroup':
            sort = sort ? `${sort}&usergroup=${this.usergroupId}` : null;
            break;
          case 'user':
            sort = sort ? `${sort}&user=${this.data.id}` : null;
            break;

          default:
            break;
        }
      }

      // Create the params array for the request
      let params = [
        sort,
        perPage,
        page,
      ];

      // Update param preferences, here we keep track of them.
      this.preferences = {
        page: this.page,
        perPage: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      };

      if (this.searchTerm !== '') {
        params.push(`general=${this.searchTerm}`);
      } else {
        // Get filters (originating from the TableFilter component)
        Object.keys(this.filters).forEach((key) => {
          // Allow only filters which do not contain empty strings
          if (this.filters[key] !== '' && this.filters[key] !== null) {
            // When the filter is an array of values, provide each param.
            if (Array.isArray(this.filters[key])) {
              this.filters[key].forEach((element) => {
                params.push(`${key}[]=${element}`);
              });
            } else {
              // Add non-empty filters to params array
              params.push(`${key}=${this.filters[key]}`);
            }
          }
        });
      }

      // Join params to form query string
      params = params.filter(val => val !== null).join('&');
      params = params && `/?${params}`;

      // Remove unneccesary forward slashes from the request
      const request = `${apiUrl}${params}`.replace('//', '/');

      const response = await this.axios.get(request);

      // Ensure missing pagination does not throw error.
      response.data.meta = response.data.meta || { pagination: {} };
      return response;
    },
    onError(error) {
      // When no rusults are availible, empty the table data.
      if (error.response.status === 404) {
        this.isLoading = false;
        this.$refs.vuetable.tableData = [];
      }
    },
  },
};
